import * as React from "react"
import { CloseIcon, KeyboardArrowDownIcon } from "@design/icons/material-symbols"
import { Avatar, AvatarBadge, AvatarGroup } from "@design/ui/avatar"
import { Button } from "@design/ui/button"
import { Input } from "@design/ui/input"
import { Kbd } from "@design/ui/kbd"

export interface ModalBXsU9PJPGdHkA5xZcxCesE1997133026Wiring {
  modalHeaderContent?: React.ReactNode
  close: React.ComponentProps<typeof CloseIcon>
  modalContent?: React.ReactNode
  input?: Omit<React.ComponentProps<typeof Input>, "type" | "defaultValue">
  selectShowIcon?: boolean
  selectPlaceholder?: string
  iconCaretDown?: React.ComponentProps<typeof KeyboardArrowDownIcon>
  avatarGroup?: Omit<React.ComponentProps<typeof AvatarGroup>, "data-size" | "children">
  avatarGroupSlot?: React.ReactNode
  avatar?: Omit<React.ComponentProps<typeof Avatar>, "size" | "data-variant" | "children">
  avatarFallbackText?: string
  avatarShowBadge?: boolean
  avatarBadge?: Omit<React.ComponentProps<typeof AvatarBadge>, "data-type" | "children">
  modalActionsSlot?: React.ReactNode
  button?: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  buttonShowIconStart?: boolean
  buttonLabel?: string
  buttonShowKbd?: boolean
  kbd?: Omit<React.ComponentProps<typeof Kbd>, "children">
  kbdShowLeftIcon?: boolean
  kbdLabel?: string
  kbdShowRightIcon?: boolean
  buttonShowIconEnd?: boolean
  button2?: Omit<React.ComponentProps<typeof Button>, "variant" | "size" | "children">
  buttonShowIconStart2?: boolean
  buttonLabel2?: string
  buttonShowKbd2?: boolean
  kbd2?: Omit<React.ComponentProps<typeof Kbd>, "children">
  kbdShowLeftIcon2?: boolean
  kbdLabel2?: string
  kbdShowRightIcon2?: boolean
  buttonShowIconEnd2?: boolean
}

export const ModalBXsU9PJPGdHkA5xZcxCesE1997133026Context = React.createContext<ModalBXsU9PJPGdHkA5xZcxCesE1997133026Wiring | null>(null)

export function useWiring(): ModalBXsU9PJPGdHkA5xZcxCesE1997133026Wiring {
  const wiring = React.useContext(ModalBXsU9PJPGdHkA5xZcxCesE1997133026Context)
  if (wiring === null) {
    throw new Error("ModalBXsU9PJPGdHkA5xZcxCesE1997133026Screen: render inside <ModalBXsU9PJPGdHkA5xZcxCesE1997133026Context.Provider>")
  }
  return wiring
}
